export { default as NikoFacilityOrderNewFlowInventoryPreviewTemplate } from './NikoFacilityOrderNewFlowInventoryPreviewTemplate';